
import SelectSession from '@/components/events/SelectSession.vue'
import { mockSession } from '@/mocks/mocks'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'SelectSessionStory',
  components: { SelectSession },
})
export default class extends Vue {
  selected = null

  messageRules: MessageRule[] = [
    {
      id: '1',
      portal_id: '',
      seller_id: '',
      triggers: {
        date_or_session: [
          {
            date_range: {
              start: '2000-01-01',
              end: '2100-01-01',
            },
          },
        ],
      },
      actions: {
        session_annotation: {
          message: 'Peak Pricing',
          style: 'info',
        },
      },
    },
  ]

  event = {
    id: '123',
    ticketGroups: [
      {
        id: '456',
        types: [{ name: 'Admission' }],
      },
    ],
    meta: {},
    venue: {
      timezone: 'Pacific/Auckland',
    },
    messageRules: this.messageRules,
  }

  sessions = [
    mockSession(10),
    mockSession(11, { availableCapacity: 10 }),
    mockSession(12, { sold_out: true }),
    mockSession(13, { sold_out: true }), // Also conflicts
    mockSession(14), // Conflicts
    mockSession(15),
    mockSession(16),
    mockSession(17),
    mockSession(18),
    mockSession(19),
    mockSession(20, { availableCapacity: 10 }),
    mockSession(21),
    mockSession(22),
    mockSession(23),
  ]
}
